import "#packages/ecma402-abstract/DateTimeFormat/FormatDateTimePattern.js";
import { PartitionDateTimeRangePattern } from "#packages/ecma402-abstract/DateTimeFormat/PartitionDateTimeRangePattern.js";
import "#packages/ecma402-abstract/DateTimeFormat/ToLocalTime.js";
export function FormatDateTimeRange(dtf, x, y, implDetails) {
	const parts = PartitionDateTimeRangePattern(dtf, x, y, implDetails);
	let result = "";
	for (const part of parts) {
		result += part.value;
	}
	return result;
}
